import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33a0e342"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "burger-menu-overlay"
}
const _hoisted_9 = { class: "navbar-end" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Tableau de bord ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Carte ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Se connecter ")
const _hoisted_13 = {
  key: 3,
  class: "navbar-item has-dropdown is-hoverable"
}
const _hoisted_14 = { class: "navbar-link" }
const _hoisted_15 = { class: "navbar-dropdown is-right" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Créer mon portefeuille ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Demandes de comptes ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Demandes de crédit ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 4,
  class: "dropdown-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'dashboard' },
        class: "navbar-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNav = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "is-rounded",
            src: _ctx.$config.logoUrl
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        role: "button",
        class: _normalizeClass(["navbar-burger", { 'is-active': _ctx.showNav }]),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "navbarBasicExample",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNav = !_ctx.showNav))
      }, _hoisted_7, 2)
    ]),
    _createElementVNode("div", {
      id: "navbarBasicExample",
      class: _normalizeClass(["navbar-menu", { 'is-active': _ctx.showNav }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNav = false))
    }, [
      (_ctx.showNav)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.getLog)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/dashboard",
              class: "navbar-item"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.hasMapUrl)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/carto",
              class: "navbar-item"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.getLog)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: "/",
              class: "navbar-item"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.getLog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.userProfile?.name ? _ctx.userProfile.name : "Utilisateur"), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("a", {
                  href: _ctx.profilePageUrl,
                  target: "_blank",
                  class: "navbar-item"
                }, " Profil ", 8, _hoisted_16),
                (_ctx.hasUnconfiguredBackend)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/create-account",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_18,
                (
                _ctx.getLog &&
                (_ctx.hasUserAccountValidationRights ||
                  _ctx.hasCreditRequestValidationRights)
              )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.hasUserAccountValidationRights)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/admin/pending-accounts",
                            class: "dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.hasCreditRequestValidationRights)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: "/admin/pending-credits",
                            class: "dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_21
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.helpUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: _ctx.helpUrl,
                      class: "dropdown-item"
                    }, " Aide ", 8, _hoisted_22))
                  : _createCommentVNode("", true),
                (_ctx.cguUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      href: _ctx.cguUrl,
                      class: "dropdown-item"
                    }, " CGU ", 8, _hoisted_23))
                  : _createCommentVNode("", true),
                (_ctx.helpUrl || _ctx.cguUrl)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_24))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "dropdown-item"
                }, " Déconnexion ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}